import type {AgentChatAction} from './actions';
import {agentChatReducer} from './reducer';
import type {AgentChatState} from './thread';
import {createDefaultState} from './thread';

export interface AgentChatStore {
  getState(): AgentChatState;
  dispatch(action: AgentChatAction): void;
  subscribe(listener: () => void): () => void;
}

export function createAgentChatStore(): AgentChatStore {
  let state = createDefaultState();
  const listeners = new Set<() => void>();

  return {
    getState: () => state,
    dispatch: action => {
      state = agentChatReducer(state, action);
      // NOTE: Snapshot listener array to avoid mutations during iteration.
      for (const listener of Array.from(listeners)) {
        listener();
      }
    },
    subscribe: listener => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
